export default "__VITE_ASSET__BxDZN$qm__"